import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { upsertRatePlan } from 'modules/settings/api/upsertRatePlan';

export const useMutationUpsertRatePlan = (id?: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(upsertRatePlan, {
    onSuccess: response => {
      id === undefined
        ? successToast(t('ratePlanSuccessfullyEntered'))
        : successToast(t('ratePlanSuccessfullyEdited'));

      queryClient.refetchQueries(QUERY_KEYS.SETTINGS_RATE_PLANS);
    },
    onError: () => {
      errorToast();
    },
  });
};
